import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import Cookies from 'js-cookie';
import {  useDispatch } from 'react-redux';
import './Success.css';

import { Footer } from "../../components/footer/footer";
import Googleadshorizontal from "../../components/google-AdSense/Googleadshorizontal";
import Navbarr from "../../components/header/Navbarr";
import ScrollButton from "../../components/scrollbutton/ScrollButton";
import Subheader from "../../components/subheader/Subheader";

import { ReactComponent as ICONSuccess } from "../../assets/success.svg";
import { useSubscription } from '../../shared/hooks/useSubscription';

function Success() {
  const firebaseUseruid = Cookies.get('firebaseuid');
  const { subscriptionInfo, loading, error } = useSubscription(firebaseUseruid);

  const dispatch = useDispatch();

  useEffect(() => {
    const canvas = document.getElementById('custom_canvas')

    if (typeof JSConfetti !== "undefined" && canvas) {
      // eslint-disable-next-line no-undef
      const jsConfetti = new JSConfetti({ canvas });

      for (let i = 0; i < 2; i++) {
        setTimeout(() => {
          jsConfetti.addConfetti();
        }, i * 1000);
      }
    } else {
      console.warn("JSConfetti no está disponible todavía");
    }
  }, []);

  return (<div>
    <Navbarr/>

    <div className="after-nav-dsubheader containers con_div">
      <Googleadshorizontal props="mt-2 mb-2 text-center"/>
      <Subheader />
      
      <div className='h-100 min-vh-100'>
        <h1 className='mt-5 text-white fw-bold text-center'>
          Success Subscription
        </h1>

        <canvas id="custom_canvas"></canvas>

        <div className="d-flex gap-5 justify-content-center flex-wrap mb-5 postion-relative">
          <ICONSuccess className='w-icon'/>
        </div>
      </div>
    </div>
    <Footer />
    <ScrollButton />
  </div>);
}

export default Success;